import {
    NavController,
    Platform,
    ToastController,
    LoadingController,
    Loading,
} from "ionic-angular";
import { LicenciasPorEquipo_Licencia } from "./licencias";
import {
    Designaciones_Dorsal,
    Alineados,
    Designaciones_Cambios,
    Designaciones_Goles,
    Designaciones_Amonestaciones,
    Designaciones_Partido,
} from "./designaciones";
import {
    iDesignacionesAPI,
    pouchdb,
    iLicencias,
    iFotos,
    iActaCustodiaMin,
    iActas_ConfirmarAlineaciones,
} from "../services/pouchdb/pouchdb.service";
import { Http } from "@angular/http";
import { APIOnLine } from "../services/api/api.services";

export interface iConfiguracionAPI {
    url: string;
    urlOnline: string;
    urlMiniatura: string;
    urlArchivoAlineacion: string;
    urlAPIs: iAPIS[];
}
export interface iAPIS {
    urlApi: string;
    urlNombre: string;
}
export interface iConfiguracionesInternas {
    comprobarCondicionesFinalizacion: boolean;
    comprobarGoles: boolean;
    comprobarParticipacion: boolean;
    declaracionesCOVID: boolean;
    entrenadorDelegado: string;
    firmaOperacionesArbitro: boolean;
    motivosSuspensionNoIniciado: boolean;
    observacionesEnActa: boolean;
    estadisticas: boolean;
}
export interface iConfiguracionDerechos {
    activar: boolean;
    nuevos: boolean;
}
export interface iIonicConfig {
    id: string;
}
export interface iConfiguracion {
    api: iConfiguracionAPI; // URL de la API para obtener la información de las designaciones, etc.
    beta: boolean; // Indica si es la versión Beta de la aplicación
    custodia: boolean; // Indica si se debe presentar la opción de custodia
    federacion: number; // Número de la Federación donde se gestionan las actas
    derechosArbitrales: iConfiguracionDerechos; // Indica si se deben cargar los derechos arbitrales o no
    internas: iConfiguracionesInternas; // Configuraciones internas de la aplicación, para poder manejar la aplicación desde las distintas Federaciones.
    ionic: iIonicConfig; // Configuración de la aplicación en IONIC
    lesionados: boolean; // Indica si se activa la opción de lesionados en la parte de resultados de la web.
    online: boolean; // Indica si es la versión online
    pruebas: boolean; // Indica si se está en la versión en pruebas
    version: string; // Versión de la aplicación
    vistaEquipo: string; // Para las pantallas relacionadas con los datos de cada equipo, indica si se cargará la vista "lista" o la vista "tabla"
}

// Interfaz para la gestión de las incidencias en la aplicación
export interface iLogs {
    _id: string;
    _rev?: string;
    type: string;
    fecha: Date;
    controlador: string;
    metodo: string;
    operacion: string;
    esError: boolean;
    datos: string;
    datosError: string;
    idDesignacion: number;
}

export class BasePage {
    //#region Constantes del controlador
    public readonly _codigosAuxiliares: Array<string> = [
        "D",
        "DS",
        "DFB",
        "DJ",
        "DSB",
        "DSJ",
    ];
    public readonly _rangoEnteros: number = 2147483647;
    //#endregion

    // #region Propiedades del controlador
    public carga: Loading;
    public configuraciones: iConfiguracion;
    public designacion: iDesignacionesAPI = undefined;
    // #endregion

    constructor(
        public navCtrl: NavController,
        public platform: Platform,
        public http: Http,
        public toastCtrl: ToastController,
        public DBService: pouchdb.DBService,
        public loadingCtrl: LoadingController,
        public Persistentes: APIOnLine.Persistentes = null
    ) {
        this.Persistentes.GetConfiguracion()
            .then((resultado: iConfiguracion) => {
                this.configuraciones = resultado;
            })
            .catch((error) => this.Mensaje(error, "", 0));
    }

    // #region Métodos del controlador

    public Atras(): void {
        this.navCtrl.pop();
    }

    // #region designacion

    /**
     * Devuleve una promisa con un booleano indicando si para la designación relacionada, las alineaciones están confirmadas.
     * @param designacion Datos de la designación actual
     */
    public AlineacionesConfirmadas(designacion: iDesignacionesAPI): boolean {
        let resultado: boolean = false;

        if (designacion != null && designacion.partido != null) {
            if (
                designacion.partido.confirmarAlineacionesLocal != null &&
                ((designacion.partido.confirmarAlineacionesLocal.idLicencia >
                    0 &&
                    designacion.partido.confirmarAlineacionesLocal.firma
                        .length > 0) ||
                    designacion.partido.confirmarAlineacionesLocal
                        .equipoNoPresentado == true) &&
                designacion.partido.confirmarAlineacionesVisitante != null &&
                ((designacion.partido.confirmarAlineacionesVisitante
                    .idLicencia > 0 &&
                    designacion.partido.confirmarAlineacionesVisitante.firma
                        .length > 0) ||
                    designacion.partido.confirmarAlineacionesVisitante
                        .equipoNoPresentado == true)
            ) {
                resultado = true;
            }
        }

        return resultado;
    }

    /**
     * Indica si la designación actual está
     */
    public DesignacionCerrada(designacion: iDesignacionesAPI): boolean {
        let resultado: boolean = false;

        if (
            designacion != null &&
            designacion.cerrada != undefined &&
            designacion.cerrada
        ) {
            resultado = true;
        }

        return resultado;
    }

    /**
     * Indica si la designación es un partido de Fútbol Sala
     */
    public EsFutbolSala(): boolean {
        let resultado: boolean = false;

        if (
            this.designacion != null &&
            this.designacion.competicion != null &&
            this.designacion.competicion.modalidad.nombre
                .trim()
                .toUpperCase()
                .indexOf("FÚTBOL SALA") >= 0
        ) {
            resultado = true;
        }

        return resultado;
    }

    /**
     * Indica si la designación es un partido de Fútbol 8 (fútbol base)
     */
    public EsFutbol8(): boolean {
        let resultado: boolean = false;

        if (
            this.designacion != null &&
            this.designacion.competicion != null &&
            this.designacion.competicion.nTitulares == 8
        ) {
            resultado = true;
        }

        return resultado;
    }

    /**
     * Guarda los datos de la custodia pasada como parámetro, devolviendo esta actualizada
     * @param custodia Datos de la custodia
     */
    public GuardarCustodia(
        custodia: iActaCustodiaMin
    ): Promise<void | iActaCustodiaMin> {
        if (custodia._id.trim().length > 0) {
            // Actualización de los datos de la custodia
            return this.DBService.CustodiaV2_Update(custodia);
        } else {
            return this.DBService.CustodiaV2_Create(
                custodia,
                this.designacion.id_Designacion
            );
        }
    }

    /**
     * Guardado de los datos de la designación
     */
    public GuardarDesignacion(): void {
        // Guardado de los datos de la designación
        this.DBService.DesignacionesUpdate(this.designacion)
            .then((resultado: PouchDB.Core.Response) => {
                if (resultado.ok) {
                    this.designacion._id == resultado.id;
                    this.designacion._rev = resultado.rev;
                }
            })
            .catch((error) =>
                this.Error(
                    JSON.stringify(error),
                    "basePage",
                    "GuardarDesignacion",
                    "ERROR: No se ha podido guardar los datos de la designación: " +
                        this.designacion.id_Designacion.toString()
                )
            );
    }

    /**
     * Guarda los datos de la designación y devuelve una promisa con un booleano que indica si se reliazó la operación
     */
    public GuardarDesignacionConRespuesta(): Promise<boolean> {
        return this.DBService.DesignacionesUpdate(this.designacion)
            .then((resultado: PouchDB.Core.Response) => {
                if (resultado.ok) {
                    this.designacion._id = resultado.id;
                    this.designacion._rev = resultado.rev;

                    let datosDesignacion: Designaciones_Partido = Object.assign(
                        {},
                        this.designacion.partido
                    );
                    datosDesignacion.listaFirmas = [];

                    this.GuardarLog(
                        JSON.stringify(datosDesignacion),
                        "basePage",
                        "GuardarDesignacionConRespuesta",
                        "Guardado de los datos de la designación."
                    );

                    return Promise.resolve(true);
                } else {
                    return Promise.reject(
                        "No se ha podido actualizar los datos de la designación actual."
                    );
                }
            })
            .catch((error) => Promise.reject(error));
    }

    public ObtenerCodigosAmonestacion(): Promise<any> {
        return this.DBService.CodigosAmonestacionGelAll()
            .then((resultado: PouchDB.Find.FindResponse<any>) => {
                let datos: any = undefined;
                if (resultado.docs != null && resultado.docs.length > 0) {
                    datos = resultado.docs;
                }

                return Promise.resolve(datos);
            })
            .catch((error) =>
                this.Error(
                    JSON.stringify(error),
                    "basePage",
                    "ObtenerCodigosAmonestaciones",
                    "ERROR: Obteniendo desde la API la lista de los códigos de amonestación."
                )
            );
    }

    public ObtenerConfirmacionAlineacion(
        idDesignacion: number,
        equipoLocal: boolean
    ): Promise<undefined | iActas_ConfirmarAlineaciones> {
        return this.DBService.ConfirmarAlineaciones_GetByDesignacion(
            idDesignacion,
            equipoLocal
        );
    }

    /**
     * Obtiene el registro de custodia asociada con la designación pasada como parámetro
     * @param idDesignacion Identificador de la designación
     */
    public ObtenerCustodia(
        idDesignacion: number
    ): Promise<undefined | iActaCustodiaMin> {
        return this.DBService.CustodiaV2_GetByDesignacion(idDesignacion);
    }

    /**
     * Obtiene la designación según su identificador y su usuario, en forma de promesa
     * @param idUsuario     Identificador del usuario actual
     * @param idDesignacion Identificador de la designación
     */
    public ObtenerDesignacion(
        idUsuario: number,
        idDesignacion: number
    ): Promise<undefined | iDesignacionesAPI> {
        return this.DBService.DesignacionesGetById(idUsuario, idDesignacion);
    }

    public ObtenerFoto(idJugador: number): Promise<void | iFotos> {
        return this.DBService.FotosPorJugador(idJugador)
            .then((resultado: PouchDB.Find.FindResponse<iFotos>) => {
                let datos: iFotos = undefined;

                if (resultado.docs != null && resultado.docs.length > 0) {
                    datos = resultado.docs[0];
                }
                return Promise.resolve(datos);
            })
            .catch((error) =>
                this.Error(
                    JSON.stringify(error),
                    "basePage",
                    "ObtenerFoto",
                    "ERROR: Obteniendo desde la BD la fotografía del jugador: " +
                        idJugador.toString()
                )
            );
    }

    /**
     * Obtiene la lista de fotografías que están relacionadas con los alineados pasados como parámetro
     * @param jugadores Lista de alineados
     */
    public ObtenerFotos(
        jugadores: Array<Alineados>
    ): Promise<void | Array<iFotos>> {
        let promesas: Array<Promise<PouchDB.Find.FindResponse<iFotos>>> = [];
        let datos: Array<iFotos> = [];

        jugadores.forEach((valor: Alineados, i: number) => {
            promesas.push(this.DBService.FotosPorJugador(valor.id_Licencia));
        });

        return Promise.all(promesas)
            .then((resultado: Array<PouchDB.Find.FindResponse<iFotos>>) => {
                if (resultado != null) {
                    resultado.forEach(
                        (
                            valor: PouchDB.Find.FindResponse<iFotos>,
                            i: number
                        ) => {
                            if (valor.docs != null && valor.docs.length > 0) {
                                datos.push(valor.docs[0]);
                            }
                        }
                    );
                }
                return Promise.resolve(datos);
            })
            .catch((error) =>
                this.Error(
                    JSON.stringify(error),
                    "basePage",
                    "ObtenerFotos",
                    "ERROR: Obteniendo desde la BD la lista de fotos de los jugadores."
                )
            );
    }

    /**
     * Obtiene la lista de licencias que están relacionadas con la designación y el equipo pasado como parámetro
     * @param designacion     Datos de la designación
     * @param idEquipo        Identificador del equipo
     */
    public ObtenerLicencias(
        designacion: iDesignacionesAPI,
        idEquipo: number
    ): Promise<void | iLicencias> {
        let datos: iLicencias = undefined;

        return this.DBService.LicenciasPorDesignacionYEquipo(
            designacion.id_Designacion,
            idEquipo
        )
            .then((resultado: PouchDB.Find.FindResponse<iLicencias>) => {
                if (resultado.docs != null && resultado.docs.length > 0) {
                    datos = resultado.docs[0];
                }
                return Promise.resolve(datos);
            })
            .catch((error) =>
                this.Error(
                    JSON.stringify(error),
                    "basePage",
                    "ObtenerLicencias",
                    "ERROR: Obteniendo desde la BD la lista de licencias de la designación: " +
                        designacion.id_Designacion.toString()
                )
            );
    }

    /**
     * Ordena la lista de licencias pasada como parámetro, devolviendo la lista ordenada
     * @param licencias   Lista de licencias a ordenar
     * @param dorsales    Lista de dorsales asociadas con las licencias
     */
    public OrdenarLicencias(
        licencias: Array<LicenciasPorEquipo_Licencia>,
        dorsales: Array<Designaciones_Dorsal>
    ): Array<LicenciasPorEquipo_Licencia> {
        let resultado: Array<LicenciasPorEquipo_Licencia> = licencias;

        if (licencias != null && licencias.length > 0) {
            for (var i = 0; i < licencias.length; i++) {
                for (var j = 0; j < licencias.length; j++) {
                    let nombreCompleto1: string =
                        licencias[i].apellido1 +
                        " " +
                        licencias[i].apellido2 +
                        " " +
                        licencias[i].nombre;
                    let nombreCompleto2: string =
                        licencias[j].apellido1 +
                        " " +
                        licencias[j].apellido2 +
                        " " +
                        licencias[j].nombre;
                    let dorsal1: number = this.ObtenerDorsal(
                        licencias[i],
                        dorsales
                    );
                    let dorsal2: number = this.ObtenerDorsal(
                        licencias[j],
                        dorsales
                    );

                    if (
                        i != j &&
                        (dorsal1 < dorsal2 ||
                            (dorsal1 == dorsal2 &&
                                nombreCompleto1 < nombreCompleto2))
                    ) {
                        let aux: LicenciasPorEquipo_Licencia = licencias[i];

                        licencias.splice(i, 1, licencias[j]);
                        licencias.splice(j, 1, aux);
                    }
                }
            }
        }

        return resultado;
    }

    /**
     * Ordena la lista de alineados pasada como parámetro, devolviendo la lista ordenada
     * @param alineados   Lista de alineados a ordenar
     * @param dorsales    Lista de dorsales asociadas con las licencias
     */
    public OrdenarAlineados(
        alineados: Array<Alineados>,
        dorsales: Array<Designaciones_Dorsal>
    ): Array<Alineados> {
        let resultado: Array<Alineados> = alineados;

        if (alineados != null && alineados.length > 0) {
            for (var i = 0; i < alineados.length; i++) {
                for (var j = 0; j < alineados.length; j++) {
                    let nombreCompleto1: string =
                        alineados[i].apellido1 +
                        " " +
                        alineados[i].apellido2 +
                        ", " +
                        alineados[i].nombre;
                    let nombreCompleto2: string =
                        alineados[j].apellido1 +
                        " " +
                        alineados[j].apellido2 +
                        ", " +
                        alineados[j].nombre;
                    let dorsal1: number = this.ObtenerDorsalDeAlineado(
                        alineados[i],
                        dorsales
                    );
                    let dorsal2: number = this.ObtenerDorsalDeAlineado(
                        alineados[j],
                        dorsales
                    );

                    if (
                        i != j &&
                        (dorsal1 < dorsal2 ||
                            (dorsal1 == dorsal2 &&
                                nombreCompleto1 < nombreCompleto2))
                    ) {
                        let aux: Alineados = alineados[i];

                        alineados.splice(i, 1, alineados[j]);
                        alineados.splice(j, 1, aux);
                    }
                }
            }
        }

        return resultado;
    }

    // #endregion

    // #region designacion.derechos

    /**
     * Devuelve los datos de la configuración de los derechos arbitrales
     */
    public ConfiguracionDerechos(): Promise<iConfiguracionDerechos> {
        return new Promise<iConfiguracionDerechos>((resolve, reject) => {
            if (this.configuraciones != undefined) {
                resolve(this.configuraciones.derechosArbitrales);
            } else {
                this.http
                    .get("./assets/data/datos.json")
                    .toPromise()
                    .then((resultado: any) => {
                        this.configuraciones = <iConfiguracion>resultado.json();
                        resolve(this.configuraciones.derechosArbitrales);
                    })
                    .catch((error) =>
                        this.Error(
                            JSON.stringify(error),
                            "basePage",
                            "ConfiguracionDerechos",
                            "ERROR: Obteniendo desde la aplicación, la configuración de los derechos arbitrales."
                        )
                    );
            }
        });
    }

    /**
     * Indica si los derechos arbitrales están compartidos.
     */
    public DerechosCompartidos(): boolean {
        let resultado: boolean = false;

        if (
            this.NuevosDerechos() &&
            this.designacion.nuevosDerechos.compartido
        ) {
            resultado = true;
        } else if (
            !this.NuevosDerechos() &&
            this.designacion.derechos.compartido
        ) {
            resultado = true;
        }

        return resultado;
    }

    /**
     * Comprueba si se ha completado correctamente los derechos arbitrales, según el equipo pasado como parámetro
     * @param esLocal Indica si es el equipo local
     * Si se está trabajando con los nuevos derechos arbitrales, siempre que se esté la propiedad "pagoRealizadoL" a true, indica que se han marcado como abonados (o no) los derechos arbitrales.
     */
    public DerechosCorrectos(esLocal: boolean): boolean {
        let resultado: boolean = false;

        if (this.designacion != null) {
            if (this.NuevosDerechos()) {
                if (
                    (this.designacion.nuevosDerechos.pagoRealizadoL &&
                        esLocal) ||
                    (this.designacion.nuevosDerechos.pagoRealizadoV && !esLocal)
                ) {
                    resultado = true;
                }
            } else {
                if (esLocal) {
                    if (this.designacion.derechos.efecLoc) {
                        if (
                            this.designacion.derechos.abonaTotLoc ||
                            (this.designacion.derechos.abonaParLoc &&
                                this.designacion.derechos.parcialLoc > 0) ||
                            this.designacion.derechos.noAbonaLoc
                        ) {
                            resultado = true;
                        }
                    }
                } else {
                    if (
                        this.designacion.derechos.efecVis != null &&
                        (this.designacion.derechos.abonaTotVis ||
                            this.designacion.derechos.abonaParVis ||
                            this.designacion.derechos.noAbonaVis) &&
                        ((this.designacion.derechos.abonaTotVis &&
                            this.designacion.derechos.parcialVis > 0) ||
                            !this.designacion.derechos.abonaParVis)
                    ) {
                        resultado = true;
                    }
                    if (this.designacion.derechos.efecVis) {
                        if (
                            this.designacion.derechos.abonaTotVis ||
                            (this.designacion.derechos.abonaParVis &&
                                this.designacion.derechos.parcialVis > 0) ||
                            this.designacion.derechos.noAbonaVis
                        ) {
                            resultado = true;
                        }
                    }
                }
            }
        }

        return resultado;
    }

    /**
     * Indica si se están utilizando los nuevos derechos arbitrales (con la tabla Actas_Derechos de la base de datos)
     */
    public NuevosDerechos(): boolean {
        let resultado: boolean = false;

        if (
            this.designacion &&
            this.designacion.nuevosDerechos &&
            this.designacion.nuevosDerechos.idDerechos > 0
        ) {
            resultado = true;
        }

        return resultado;
    }

    /**
     * Comprueba si para el equipo pasado como parámetro de la designación actual, este abona sus derechos arbitrales por el banco
     * @param esLocal Indica si es el equipo local
     */
    public PagaPorBanco(esLocal: boolean): boolean {
        let resultado: boolean = false;

        if (this.NuevosDerechos()) {
            if (
                (esLocal && this.designacion.nuevosDerechos.desdeBancoL) ||
                (!esLocal && this.designacion.nuevosDerechos.desdeBancoV)
            ) {
                resultado = true;
            }
        }

        return resultado;
    }

    /**
     * Indica si se han establecidos los datos del pago y puede darse este como realizado.
     * Si se está trabajando con los nuevos derechos arbitrales, siempre que se esté la propiedad "pagoRealizadoL" a true, indica que se han marcado como abonados (o no) los derechos arbitrales.
     */
    public PagoRealizado(esLocal: boolean): boolean {
        let resultado: boolean = false;

        if (this.designacion) {
            // Se comprueba si se están utilizando los nuevos derechos arbitrales o los antiguos
            if (this.NuevosDerechos()) {
                if (
                    (this.designacion.nuevosDerechos.pagoRealizadoL &&
                        esLocal) ||
                    (this.designacion.nuevosDerechos.pagoRealizadoV && !esLocal)
                ) {
                    resultado = true;
                }
            } else if (
                (this.designacion.derechos &&
                    this.designacion.derechos.pagoRealizadoLocal &&
                    esLocal) ||
                (this.designacion.derechos.pagoRealizadoVisitante && !esLocal)
            ) {
                resultado = true;
            }
        }

        return resultado;
    }

    //#endregion

    // #region designacion.partido

    // NOTA: He tenido que poner estos métodos aquí, porque no funcionan si están dentro de la clase relacionada

    /**
     * Indica si el capitán establecido para el equipo actual
     * @param esLocal     Indica si es el equipo local
     */
    public CapitanEstablecido(esLocal: boolean): boolean {
        let resultado: boolean = false;

        if (
            (esLocal && this.designacion.partido.idCapitanLocal > 0) ||
            (!esLocal && this.designacion.partido.idCapitanVisitante)
        ) {
            resultado = true;
        }

        return resultado;
    }

    /**
     * Se verifican las condiciones para finalizar la designación: - Se busca si los minutos en las amonestaciones y los cambios tienen algún decimal. - Se comprueba si hay que eliminar las firmas o no (envío de modelo al servidor). - Elimina los datos de la competición para que no se envíe toda su información.
     * @param designacion Datos de la designación a comprobar
     * @param eliminarFirmas  Indica si se desea eliminar las firmas de la designación
     */
    public CondicionesFinalizacion(
        designacion: iDesignacionesAPI,
        eliminarFirmas: boolean = false
    ): void {
        // Minutos en las amonestaciones
        if (
            designacion.partido.listaAmonestaciones != null &&
            designacion.partido.listaAmonestaciones.length > 0
        ) {
            designacion.partido.listaAmonestaciones.forEach(
                (valor: Designaciones_Amonestaciones, i: number) => {
                    let m: string =
                        valor.minuto != undefined
                            ? valor.minuto.toString()
                            : "";

                    if (m.indexOf(".") >= 0) {
                        valor.minuto = parseInt(m.split(".")[0]);
                        designacion.partido.listaAmonestaciones.splice(
                            i,
                            1,
                            valor
                        );
                    }
                    if (m.indexOf(":") >= 0) {
                        valor.minuto = parseInt(m.split(":")[0]);
                        designacion.partido.listaAmonestaciones.splice(
                            i,
                            1,
                            valor
                        );
                    }
                }
            );
        }

        // Minutos en los cambios
        if (
            designacion.partido.listaCambios != null &&
            designacion.partido.listaCambios.length > 0
        ) {
            designacion.partido.listaCambios.forEach(
                (valor: Designaciones_Cambios, i: number) => {
                    let m: string =
                        valor.minuto != undefined
                            ? valor.minuto.toString()
                            : "";

                    if (m.indexOf(".") >= 0) {
                        valor.minuto = parseInt(m.split(".")[0]);
                        designacion.partido.listaCambios.splice(i, 1, valor);
                    }
                    if (m.indexOf(":") >= 0) {
                        valor.minuto = parseInt(m.split(":")[0]);
                        designacion.partido.listaCambios.splice(i, 1, valor);
                    }
                }
            );
        }

        designacion.competicion = undefined;

        // Eliminación de las firmas
        if (eliminarFirmas) {
            // Eliminación de las firmas
            if (
                designacion.arbitro2 != undefined &&
                designacion.arbitro2 != null
            ) {
                designacion.arbitro2.firma = "";
            }
            if (
                designacion.cronometrador != undefined &&
                designacion.cronometrador != null
            ) {
                designacion.cronometrador.firma = "";
            }
            designacion.partido.listaFirmas = [];
        }
    }

    /**
     * Comprueba si se dan las condiciones para cumplir con los requisitos de alineación. Si se devuelve una cadena vacía, indica que se cumplen las condiciones. Si no, se especifican las condiciones que no se cumplen.
     * @param esLocal     Indica si es el equipo local
     */
    public CumpleCondicionesAlineacion(esLocal: boolean): string {
        let cumpleTitulares: boolean = true,
            cumpleEntrenador: boolean = false,
            cumpleDelegado: boolean = false,
            cumpleDelegadoCampo: boolean = false,
            cumpleCapitan: boolean = false;
        let plantilla: string =
            "En el equipo actual, NO HA COMPLETADO toda la información necesaria";

        // Titulares
        if (
            (esLocal &&
                this.designacion.competicion.nTitulares !=
                    this.designacion.partido.listaTitularesLocal.length) ||
            (!esLocal &&
                this.designacion.competicion.nTitulares !=
                    this.designacion.partido.listaTitularesVisitante.length)
        ) {
            cumpleTitulares = false;
            plantilla += ": Tiene menos titulares de los necesarios";
        }
        // Entrenador
        if (
            (esLocal && this.designacion.partido.idEntrenadorLocal > 0) ||
            (!esLocal && this.designacion.partido.idEntrenadorVisitante > 0)
        ) {
            cumpleEntrenador = true;
        } else {
            plantilla += ": No se ha establecido el ENTRENADOR";
        }
        // Capitan
        if (
            (esLocal && this.designacion.partido.idCapitanLocal > 0) ||
            (!esLocal && this.designacion.partido.idCapitanVisitante > 0)
        ) {
            cumpleCapitan = true;
        } else {
            plantilla += ": No se ha establecido el CAPITÁN";
        }
        // Delegado
        if (
            (esLocal && this.designacion.partido.idDelegadoLocal > 0) ||
            (!esLocal && this.designacion.partido.idDelegadoVisitante > 0)
        ) {
            cumpleDelegado = true;
        } else {
            plantilla += ": No se ha establecido el DELEGADO";
        }
        // Delegado de campo
        if (
            (esLocal && this.designacion.partido.idDelegadoCampo > 0) ||
            !esLocal
        ) {
            cumpleDelegadoCampo = true;
        } else {
            plantilla += ": No se ha establecido el DELEGADO DE CAMPO";
        }

        if (
            cumpleCapitan &&
            cumpleDelegado &&
            cumpleDelegadoCampo &&
            cumpleEntrenador &&
            cumpleTitulares
        ) {
            return "";
        } else {
            return plantilla;
        }
    }

    /**
     * Indica si el delegado de equipo está establecido
     * @param esLocal Indica si es el equipo local
     */
    public DelegadoEstablecido(esLocal: boolean): boolean {
        let resultado: boolean = false;

        if (this.designacion != null && this.designacion.partido != null) {
            if (
                (esLocal && this.designacion.partido.idDelegadoLocal > 0) ||
                (!esLocal && this.designacion.partido.idDelegadoVisitante > 0)
            ) {
                resultado = true;
            }
        }

        return resultado;
    }

    /**
     * Indica si el delegado de campo está establecido
     */
    public DelegadoCampoEstablecido(): boolean {
        let resultado: boolean = false;

        if (this.designacion != null && this.designacion.partido != null) {
            if (this.designacion.partido.idDelegadoCampo > 0) {
                resultado = true;
            }
        }

        return resultado;
    }

    /**
     * Devuelve los datos principales de la designación, en el primer paso del proceso, formateado como cadena
     * @param esLocal Indica si es el equipo local
     */
    public Designacion1PasoFormateada(esLocal: boolean): string {
        let resultado: string = "";

        if (esLocal) {
            resultado = "EQUIPO LOCAL: " + this.designacion.equipoLocal;
            if (
                this.designacion.partido != null &&
                this.designacion.partido.listaTitularesLocal != null
            ) {
                resultado +=
                    ", TITULARES: " +
                    JSON.stringify(
                        this.designacion.partido.listaTitularesLocal
                    );
            }
            if (
                this.designacion.partido != null &&
                this.designacion.partido.listaSuplentesLocal != null
            ) {
                resultado +=
                    ", SUPLENTES: " +
                    JSON.stringify(
                        this.designacion.partido.listaSuplentesLocal
                    );
            }
            if (
                this.designacion.partido != null &&
                this.designacion.partido.listaDorsalesLocal != null
            ) {
                resultado +=
                    ", DORSALES: " +
                    JSON.stringify(this.designacion.partido.listaDorsalesLocal);
            }
            if (this.designacion.partido.idCapitanLocal != null) {
                resultado +=
                    ", CAPITAN: " +
                    this.designacion.partido.idCapitanLocal.toString();
            }
            if (this.designacion.partido.idEntrenadorLocal != null) {
                resultado +=
                    ", ENTRENADOR: " +
                    this.designacion.partido.idEntrenadorLocal.toString();
            }
            if (this.designacion.partido.idDelegadoLocal != null) {
                resultado +=
                    ", DELEGADO: " +
                    this.designacion.partido.idDelegadoLocal.toString();
            }
            if (this.designacion.partido.idDelegadoCampo != null) {
                resultado +=
                    ", DELEGADO CAMPO: " +
                    this.designacion.partido.idDelegadoCampo.toString();
            }
        } else {
            resultado = "EQUIPO VISITANTE: " + this.designacion.equipoVisitante;
            if (
                this.designacion.partido != null &&
                this.designacion.partido.listaTitularesVisitante != null
            ) {
                resultado +=
                    ", TITULARES: " +
                    JSON.stringify(
                        this.designacion.partido.listaTitularesVisitante
                    );
            }
            if (
                this.designacion.partido != null &&
                this.designacion.partido.listaSuplentesVisitante != null
            ) {
                resultado +=
                    ", SUPLENTES: " +
                    JSON.stringify(
                        this.designacion.partido.listaSuplentesVisitante
                    );
            }
            if (
                this.designacion.partido != null &&
                this.designacion.partido.listaDorsalesVisitante != null
            ) {
                resultado +=
                    ", DORSALES: " +
                    JSON.stringify(
                        this.designacion.partido.listaDorsalesVisitante
                    );
            }
            if (this.designacion.partido.idCapitanVisitante != null) {
                resultado +=
                    ", CAPITAN: " +
                    this.designacion.partido.idCapitanVisitante.toString();
            }
            if (this.designacion.partido.idEntrenadorVisitante != null) {
                resultado +=
                    ", ENTRENADOR: " +
                    this.designacion.partido.idEntrenadorVisitante.toString();
            }
            if (this.designacion.partido.idDelegadoVisitante != null) {
                resultado +=
                    ", DELEGADO: " +
                    this.designacion.partido.idDelegadoVisitante.toString();
            }
        }

        return resultado;
    }

    /**
     * Devuelve el dorsal que tiene asignada la licencia pasada como parámetro, ó 0 si no tiene un dorsal establecido
     * @param idLicencia    Identificador de la licencia
     * @param esLocal       Indica si es el equipo local
     */
    public DorsalPorLicencia(idLicencia: number, esLocal: boolean): number {
        let resultado: number = 0;

        if (this.designacion != null && this.designacion.partido != null) {
            if (esLocal) {
                if (this.designacion.partido.listaDorsalesLocal == undefined) {
                    this.designacion.partido.listaDorsalesLocal = [];
                }

                this.designacion.partido.listaDorsalesLocal.forEach(
                    (valor: Designaciones_Dorsal, i: number) => {
                        if (valor.idJugador == idLicencia) {
                            resultado = valor.dorsal;
                        }
                    }
                );
            } else {
                if (
                    this.designacion.partido.listaDorsalesVisitante == undefined
                ) {
                    this.designacion.partido.listaDorsalesVisitante = [];
                }

                this.designacion.partido.listaDorsalesVisitante.forEach(
                    (valor: Designaciones_Dorsal, i: number) => {
                        if (valor.idJugador == idLicencia) {
                            resultado = valor.dorsal;
                        }
                    }
                );
            }
        }

        return resultado;
    }

    /**
     * Indica si el dorsal que se pasa como parámetro ya está siendo utilizado por otra licencia
     * @param dorsal  Dorsal a comprobar
     * @param esLocal Indica si es el equipo local
     */
    public DorsalUsado(dorsal: number, esLocal: boolean): boolean {
        let resultado: boolean = false;

        if (this.designacion != null && this.designacion.partido != null) {
            if (esLocal) {
                if (this.designacion.partido.listaDorsalesLocal == undefined) {
                    this.designacion.partido.listaDorsalesLocal = [];
                }

                this.designacion.partido.listaDorsalesLocal.forEach(
                    (valor: Designaciones_Dorsal, i: number) => {
                        if (valor.dorsal == dorsal) {
                            resultado = true;
                        }
                    }
                );
            } else {
                if (
                    this.designacion.partido.listaDorsalesVisitante == undefined
                ) {
                    this.designacion.partido.listaDorsalesVisitante = [];
                }

                this.designacion.partido.listaDorsalesVisitante.forEach(
                    (valor: Designaciones_Dorsal, i: number) => {
                        if (valor.dorsal == dorsal) {
                            resultado = true;
                        }
                    }
                );
            }
            return resultado;
        }
    }

    /**
     * Elimina la licencia alineada cuyo identificador es pasado como párametro. También la elimina de la lista de titulares, suplentes, capitan y dorsal
     * @param idLicencia    Identificador de la licencia
     * @param esLocal       Indica si es el equipo local
     */
    public EliminarLicenciaAlineada(
        idLicencia: number,
        esLocal: boolean
    ): void {
        this.GuardarLog(
            "Licencia a eliminar: " +
                idLicencia.toString() +
                ", en equipo " +
                (esLocal ? "local" : "visitante"),
            "basePage",
            "EliminarLicenciaAlineado",
            "Eliminación de un alineado en el equipo " +
                (esLocal ? "local" : "visitante")
        );

        if (esLocal) {
            // Capitan
            if (this.designacion.partido.idCapitanLocal == idLicencia) {
                this.designacion.partido.idCapitanLocal = 0;
            }

            // Titulares
            this.designacion.partido.listaTitularesLocal.forEach(
                (valor: number, i: number) => {
                    if (valor == idLicencia) {
                        this.designacion.partido.listaTitularesLocal.splice(
                            i,
                            1
                        );
                    }
                }
            );

            // Suplentes
            this.designacion.partido.listaSuplentesLocal.forEach(
                (valor: number, i: number) => {
                    if (valor == idLicencia) {
                        this.designacion.partido.listaSuplentesLocal.splice(
                            i,
                            1
                        );
                    }
                }
            );

            // Dorsales
            this.designacion.partido.listaDorsalesLocal.forEach(
                (valor: Designaciones_Dorsal, i: number) => {
                    if (valor.idJugador == idLicencia) {
                        this.designacion.partido.listaDorsalesLocal.splice(
                            i,
                            1
                        );
                    }
                }
            );

            // Alineados
            this.designacion.partido.alineadosLocal.forEach(
                (valor: Alineados, i: number) => {
                    if (valor.id_Licencia == idLicencia) {
                        this.designacion.partido.alineadosLocal.splice(i, 1);
                    }
                }
            );
        } else {
            // Capitan
            if (this.designacion.partido.idCapitanVisitante == idLicencia) {
                this.designacion.partido.idCapitanVisitante = 0;
            }

            // Titulares
            this.designacion.partido.listaTitularesVisitante.forEach(
                (valor: number, i: number) => {
                    if (valor == idLicencia) {
                        this.designacion.partido.listaTitularesVisitante.splice(
                            i,
                            1
                        );
                    }
                }
            );

            // Suplentes
            this.designacion.partido.listaSuplentesVisitante.forEach(
                (valor: number, i: number) => {
                    if (valor == idLicencia) {
                        this.designacion.partido.listaSuplentesVisitante.splice(
                            i,
                            1
                        );
                    }
                }
            );

            // Dorsales
            this.designacion.partido.listaDorsalesVisitante.forEach(
                (valor: Designaciones_Dorsal, i: number) => {
                    if (valor.idJugador == idLicencia) {
                        this.designacion.partido.listaDorsalesVisitante.splice(
                            i,
                            1
                        );
                    }
                }
            );

            // Alineados
            this.designacion.partido.alineadosVisitante.forEach(
                (valor: Alineados, i: number) => {
                    if (valor.id_Licencia == idLicencia) {
                        this.designacion.partido.alineadosVisitante.splice(
                            i,
                            1
                        );
                    }
                }
            );
        }
    }

    /**
     * Elimina toda la información de las alineaciones, según si es el equipo local o el visitante
     * @param esLocal     Indica si es el equipo local
     */
    public EliminarAlineados(esLocal: boolean): void {
        this.GuardarLog(
            this.Designacion1PasoFormateada(esLocal),
            "basePage",
            "EliminarLicenciaAlineado",
            "Eliminación de todos los alineados en el equipo " +
                (esLocal ? "local" : "visitante")
        );

        if (esLocal) {
            // Capitan
            this.designacion.partido.idCapitanLocal = 0;
            // Titulares
            this.designacion.partido.listaTitularesLocal = [];
            // Suplentes
            this.designacion.partido.listaSuplentesLocal = [];
            // Dorsales
            this.designacion.partido.listaDorsalesLocal = [];
        } else {
            // Capitan
            this.designacion.partido.idCapitanVisitante = 0;
            // Titulares
            this.designacion.partido.listaTitularesVisitante = [];
            // Suplentes
            this.designacion.partido.listaSuplentesVisitante = [];
            // Dorsales
            this.designacion.partido.listaDorsalesVisitante = [];
        }
    }

    /**
     * Elimina las firmas de la designación pasada como parámetro
     * @param datos Designación a comprobar
     */
    public EliminarFirmas(datos: iDesignacionesAPI): iDesignacionesAPI {
        // Firmas de los árbitros, aistentes e informado
        if (datos.arbitro1 && datos.arbitro1.firma) {
            datos.arbitro1.firma = "";
        }
        if (datos.arbitro2 && datos.arbitro2.firma) {
            datos.arbitro2.firma = "";
        }
        if (datos.cronometrador && datos.cronometrador.firma) {
            datos.cronometrador.firma = "";
        }
        if (datos.asistente1 && datos.asistente1.firma) {
            datos.asistente1.firma = "";
        }
        if (datos.asistente2 && datos.asistente2.firma) {
            datos.asistente2.firma = "";
        }
        if (datos.asistente3 && datos.asistente3.firma) {
            datos.asistente3.firma = "";
        }
        if (datos.asistente4 && datos.asistente4.firma) {
            datos.asistente4.firma = "";
        }

        // Firmas de las confirmaciones de las alineaciones
        if (datos.partido && datos.partido.confirmarAlineacionesLocal) {
            datos.partido.confirmarAlineacionesLocal.firma = "";
        }
        if (datos.partido && datos.partido.confirmarAlineacionesVisitante) {
            datos.partido.confirmarAlineacionesVisitante.firma = "";
        }

        // Firmas generales
        if (datos.partido) {
            datos.partido.listaFirmas = [];
        }

        return datos;
    }

    /**
     * Indica si el entrenador está establecido
     * @param esLocal Indica si es el equipo local
     */
    public EntrenadorEstablecido(esLocal: boolean): boolean {
        let resultado: boolean = false;

        if (this.designacion != null && this.designacion.partido != null) {
            if (
                (esLocal && this.designacion.partido.idEntrenadorLocal > 0) ||
                (!esLocal && this.designacion.partido.idEntrenadorVisitante > 0)
            ) {
                resultado = true;
            }
        }

        return resultado;
    }

    /**
     * Indica si la licencia pasada como parámetro es la que está marcada como capitán
     * @param idLicencia    Identificador de la licencia
     * @param esLocal       Indica si es el equipo local
     */
    public EsCapitan(idLicencia: number, esLocal: boolean): boolean {
        let resultado: boolean = false;

        if (this.designacion != null && this.designacion.partido != null) {
            if (
                (esLocal &&
                    this.designacion.partido.idCapitanLocal == idLicencia) ||
                (!esLocal &&
                    this.designacion.partido.idCapitanVisitante == idLicencia)
            ) {
                resultado = true;
            }
        }

        return resultado;
    }

    /**
     * Indica si la licencia pasada como parámetro es la que está marcada como delegado
     * @param idLicencia    Identificador de la licencia
     * @param esLocal       Indica si es el equipo local
     */
    public EsDelegado(idLicencia: number, esLocal: boolean): boolean {
        let resultado: boolean = false;

        if (this.designacion != null && this.designacion.partido != null) {
            if (
                (esLocal &&
                    this.designacion.partido.idDelegadoLocal == idLicencia) ||
                (!esLocal &&
                    this.designacion.partido.idDelegadoVisitante == idLicencia)
            ) {
                resultado = true;
            }
        }

        return resultado;
    }

    /**
     * Indica si la licencia pasada como parámetro es la que está marcada como delegado de campo
     * @param idLicencia    Identificador de la licencia
     */
    public EsDelegadoCampo(idLicencia: number): boolean {
        let resultado: boolean = false;

        if (this.designacion != null && this.designacion.partido != null) {
            if (this.designacion.partido.idDelegadoCampo == idLicencia) {
                resultado = true;
            }
        }

        return resultado;
    }

    /**
     * Indica si la licencia pasada como parámetro es la que está marcada como entrenador
     * @param idLicencia    Identificador de la licencia
     * @param esLocal       Indica si es el equipo local
     */
    public EsEntrenador(idLicencia: number, esLocal: boolean): boolean {
        let resultado: boolean = false;

        if (this.designacion != null && this.designacion.partido != null) {
            if (
                (esLocal &&
                    this.designacion.partido.idEntrenadorLocal == idLicencia) ||
                (!esLocal &&
                    this.designacion.partido.idEntrenadorVisitante ==
                        idLicencia)
            ) {
                resultado = true;
            }
        }
        return resultado;
    }

    /**
     * Indica si el equipo pasado como parámetro es el equipo local
     * @param designacion     Datos de la designación a comprobar
     * @param idEquipo        Identificador del equipo
     */
    public EsEquipoLocal(
        designacion: iDesignacionesAPI,
        idEquipo: number
    ): boolean {
        let resultado: boolean = true;

        if (designacion != null) {
            if (designacion.idEquipoVisitante == idEquipo) {
                resultado = false;
            }
        }

        return resultado;
    }

    /**
     * Establece el capitán del equipo, según la licencia pasada como parámetro
     * @param idLicencia    Identificador de la licencia
     * @param esLocal       Indica si es el equipo local
     */
    public EstablecerCapitan(idLicencia: number, esLocal: boolean): void {
        this.GuardarLog(
            "Se establece el capitán: " +
                idLicencia.toString() +
                ", del equipo " +
                (esLocal ? "local" : "visitante"),
            "basePage",
            "EstablecerCapitan",
            "Estableciendo el capitán del equipo " +
                (esLocal ? "local" : "visitante")
        );
        if (this.designacion != null && this.designacion.partido != null) {
            if (esLocal) {
                this.designacion.partido.idCapitanLocal = idLicencia;
            } else {
                this.designacion.partido.idCapitanVisitante = idLicencia;
            }
        }
    }

    /**
     * Establece el delegado del equipo, según la licencia pasada como parámetro
     * @param idLicencia    Identificador de la licencia
     * @param esLocal       Indica si es el equipo local
     */
    public EstablecerDelegado(idLicencia: number, esLocal: boolean): void {
        this.GuardarLog(
            "Se establece el delegado: " +
                idLicencia.toString() +
                ", del equipo " +
                (esLocal ? "local" : "visitante"),
            "basePage",
            "EstablecerDelegado",
            "Estableciendo el delegado del equipo " +
                (esLocal ? "local" : "visitante")
        );
        if (this.designacion != null && this.designacion.partido != null) {
            if (esLocal) {
                if (this.designacion.partido.idDelegadoLocal == idLicencia) {
                    this.designacion.partido.idDelegadoLocal = 0;
                } else {
                    this.designacion.partido.idDelegadoLocal = idLicencia;
                }
            } else {
                if (
                    this.designacion.partido.idDelegadoVisitante == idLicencia
                ) {
                    this.designacion.partido.idDelegadoVisitante = 0;
                } else {
                    this.designacion.partido.idDelegadoVisitante = idLicencia;
                }
            }
        }
    }

    /**
     * Establece el delegado de campo, según la licencia pasada como parámetro
     * @param idLicencia    Identificador de la licencia
     */
    public EstablecerDelegadoCampo(idLicencia: number): void {
        this.GuardarLog(
            "Se establece el delegado de campo: " + idLicencia.toString(),
            "basePage",
            "EstablecerDelegadoCampo",
            "Estableciendo el delegado de campo."
        );
        if (this.designacion != null && this.designacion.partido != null) {
            if (this.designacion.partido.idDelegadoCampo == idLicencia) {
                this.designacion.partido.idDelegadoCampo = 0;
            } else {
                this.designacion.partido.idDelegadoCampo = idLicencia;
            }
        }
    }

    /**
     * Establece el entrenador del equipo, según la licencia pasada como parámetro. Si se está indicando el mismo entrenador, es que se quiere quitar
     * @param idLicencia    Identificador de la licencia
     * @param esLocal       Indica si es el equipo local
     */
    public EstablecerEntrenador(idLicencia: number, esLocal: boolean): void {
        this.GuardarLog(
            "Se establece el entrenador: " +
                idLicencia.toString() +
                ", del equipo " +
                (esLocal ? "local" : "visitante"),
            "basePage",
            "EstablecerEntrenador",
            "Estableciendo el entrenador del equipo " +
                (esLocal ? "local" : "visitante")
        );
        if (this.designacion != null && this.designacion.partido != null) {
            if (esLocal) {
                if (this.designacion.partido.idEntrenadorLocal == idLicencia) {
                    this.designacion.partido.idEntrenadorLocal = 0;
                } else {
                    this.designacion.partido.idEntrenadorLocal = idLicencia;
                }
            } else {
                if (
                    this.designacion.partido.idEntrenadorVisitante == idLicencia
                ) {
                    this.designacion.partido.idEntrenadorVisitante = 0;
                } else {
                    this.designacion.partido.idEntrenadorVisitante = idLicencia;
                }
            }
        }
    }

    /**
     * Establece el dorsal de un jugador, según los datos indicados por los parámetros pasados. Si para esa licencia ya hay un dorsal, lo elimina
     * @param idLicencia    Identificador de la licencia
     * @param dorsal        Dorsal a establecer. Si se pasa igual a 0, se obtendrá el siguiente dorsal válido
     * @param esLocal       Indica si es el equipo local
     * @param reemplazar    Indica que se quiere reemplazar el dorsal del jugador, por el que se está pasando
     */
    public EstablecerDorsal(
        idLicencia: number,
        dorsal: any,
        esLocal: boolean,
        reemplazar: boolean = false
    ): void {
        let encontrado: boolean = false;
        let numero: number = parseInt(dorsal);

        if (this.designacion != null && this.designacion.partido != null) {
            if (numero == 0) {
                numero = this.SiguienteDorsal(esLocal);
            }

            if (esLocal) {
                if (this.designacion.partido.listaDorsalesLocal == undefined) {
                    this.designacion.partido.listaDorsalesLocal = [];
                }

                // Si no es un remplazo, se comprueba si la licencia ya tiene su dorsal, para en ese caso, eliminarla
                this.designacion.partido.listaDorsalesLocal.forEach(
                    (valor: Designaciones_Dorsal, i: number) => {
                        if (!reemplazar && valor.idJugador == idLicencia) {
                            encontrado = true;
                            this.designacion.partido.listaDorsalesLocal.splice(
                                i,
                                1
                            );
                        } else if (
                            reemplazar &&
                            valor.idJugador == idLicencia
                        ) {
                            encontrado = true;
                            valor.dorsal = numero;
                            this.designacion.partido.listaDorsalesLocal.splice(
                                i,
                                1,
                                valor
                            );
                        }
                    }
                );

                if (!encontrado) {
                    // Búsqueda de la licencia en la lista de alineados local
                    this.designacion.partido.alineadosLocal.forEach(
                        (alineado: Alineados, i: number) => {
                            if (alineado.id_Licencia == idLicencia) {
                                this.designacion.partido.listaDorsalesLocal.push(
                                    {
                                        dorsal: numero,
                                        esLocal: esLocal,
                                        idJugador: idLicencia,
                                        nombre:
                                            alineado.apellido1 +
                                            " " +
                                            alineado.apellido2 +
                                            ", " +
                                            alineado.nombre,
                                    }
                                );
                                console.log(
                                    this.designacion.partido.listaDorsalesLocal
                                );
                            }
                        }
                    );
                }
            } else {
                if (
                    this.designacion.partido.listaDorsalesVisitante == undefined
                ) {
                    this.designacion.partido.listaDorsalesVisitante = [];
                }

                // Si no es un remplazo, se comprueba si la licencia ya tiene su dorsal, para en ese caso, eliminarla
                this.designacion.partido.listaDorsalesVisitante.forEach(
                    (valor: Designaciones_Dorsal, i: number) => {
                        if (!reemplazar && valor.idJugador == idLicencia) {
                            encontrado = true;
                            this.designacion.partido.listaDorsalesVisitante.splice(
                                i,
                                1
                            );
                        } else if (
                            reemplazar &&
                            valor.idJugador == idLicencia
                        ) {
                            encontrado = true;
                            valor.dorsal = numero;
                            this.designacion.partido.listaDorsalesVisitante.splice(
                                i,
                                1,
                                valor
                            );
                        }
                    }
                );

                if (!encontrado) {
                    // Búsqueda de la licencia en la lista de alineados visitante
                    this.designacion.partido.alineadosVisitante.forEach(
                        (alineado: Alineados, i: number) => {
                            if (alineado.id_Licencia == idLicencia) {
                                this.designacion.partido.listaDorsalesVisitante.push(
                                    {
                                        dorsal: numero,
                                        esLocal: esLocal,
                                        idJugador: idLicencia,
                                        nombre:
                                            alineado.apellido1 +
                                            " " +
                                            alineado.apellido2 +
                                            ", " +
                                            alineado.nombre,
                                    }
                                );
                            }
                        }
                    );
                }
            }

            this.GuardarLog(
                esLocal
                    ? JSON.stringify(
                          this.designacion.partido.listaDorsalesLocal
                      )
                    : JSON.stringify(
                          this.designacion.partido.listaDorsalesVisitante
                      ),
                "basePage",
                "EstablecerDorsal",
                "Se establece un dorsal en el equipo " +
                    (esLocal ? "local" : "visitante") +
                    " para la licencia " +
                    idLicencia.toString() +
                    " con número " +
                    numero.toString()
            );
        }
    }

    /**
     * Añade a la lista de participantes del equipo local o visitante, la licencia pasada como parámetro. Si ya está en la lista de participantes, la elimina
     * @param idLicencia Identificador de la licencia
     * @param esLocal Indica si es el equipo local
     */
    public EstablecerParticipante(idLicencia: number, esLocal: boolean): void {
        let encontrada: boolean = false;

        if (this.designacion != null && this.designacion.partido != null) {
            if (esLocal) {
                if (
                    this.designacion.partido.listaParticipantesLocal ==
                    undefined
                ) {
                    this.designacion.partido.listaParticipantesLocal = [];
                }

                this.designacion.partido.listaParticipantesLocal.forEach(
                    (valor: number, i: number) => {
                        if (valor == idLicencia) {
                            encontrada = true;
                            this.designacion.partido.listaParticipantesLocal.splice(
                                i,
                                1
                            );
                        }
                    }
                );

                if (!encontrada) {
                    this.designacion.partido.listaParticipantesLocal.push(
                        idLicencia
                    );
                }
            } else {
                if (
                    this.designacion.partido.listaParticipantesVisitante ==
                    undefined
                ) {
                    this.designacion.partido.listaParticipantesVisitante = [];
                }

                this.designacion.partido.listaParticipantesVisitante.forEach(
                    (valor: number, i: number) => {
                        if (valor == idLicencia) {
                            encontrada = true;
                            this.designacion.partido.listaParticipantesVisitante.splice(
                                i,
                                1
                            );
                        }
                    }
                );

                if (!encontrada) {
                    this.designacion.partido.listaParticipantesVisitante.push(
                        idLicencia
                    );
                }
            }

            this.GuardarLog(
                esLocal
                    ? JSON.stringify(
                          this.designacion.partido.listaParticipantesLocal
                      )
                    : JSON.stringify(
                          this.designacion.partido.listaParticipantesVisitante
                      ),
                "basePage",
                "EstablecerParticipante",
                "Se establece la participación en el equipo " +
                    (esLocal ? "local" : "visitante") +
                    " para la licencia " +
                    idLicencia.toString()
            );
        }
    }

    /**
     * Añade a la lista del quinteto inicial del equipo local o visitante, la licencia pasada como parámetro. Si ya está en la lista del quinteto final, se elimina
     * @param idLicencia Identificador de la licencia
     * @param esLocal Indica si es el equipo local
     */
    public EstablecerQuinteto(idLicencia: number, esLocal: boolean): void {
        let encontrado: boolean = false;

        if (this.designacion != null && this.designacion.partido != null) {
            if (esLocal) {
                if (this.designacion.partido.quintetoFinalLocal == undefined) {
                    this.designacion.partido.quintetoFinalLocal = [];
                }

                this.designacion.partido.quintetoFinalLocal.forEach(
                    (valor: number, i: number) => {
                        if (valor == idLicencia) {
                            encontrado = true;
                            this.designacion.partido.quintetoFinalLocal.splice(
                                i,
                                1
                            );
                        }
                    }
                );

                if (!encontrado) {
                    this.designacion.partido.quintetoFinalLocal.push(
                        idLicencia
                    );
                }
            } else {
                if (
                    this.designacion.partido.quintetoFinalVisitante == undefined
                ) {
                    this.designacion.partido.quintetoFinalVisitante = [];
                }

                this.designacion.partido.quintetoFinalVisitante.forEach(
                    (valor: number, i: number) => {
                        if (valor == idLicencia) {
                            encontrado = true;
                            this.designacion.partido.quintetoFinalVisitante.splice(
                                i,
                                1
                            );
                        }
                    }
                );

                if (!encontrado) {
                    this.designacion.partido.quintetoFinalVisitante.push(
                        idLicencia
                    );
                }
            }

            this.GuardarLog(
                esLocal
                    ? JSON.stringify(
                          this.designacion.partido.quintetoFinalLocal
                      )
                    : JSON.stringify(
                          this.designacion.partido.quintetoFinalVisitante
                      ),
                "basePage",
                "EstablecerQuinteto",
                "Se establece un jugador en el quinteto inicial en el equipo " +
                    (esLocal ? "local" : "visitante") +
                    " para la licencia " +
                    idLicencia.toString()
            );
        }
    }

    /**
     * Añade en la lista de suplentes del equipo local o visitante, la licencia pasada como parámetro. Si ya está en la lista de suplentes, la elimina.
     * @param idLicencia    Identificador de la licencia
     * @param esLocal       Indica si es el equipo local
     */
    public EstablecerSuplente(idLicencia: number, esLocal: boolean): void {
        let encontrado: boolean = false;

        if (this.designacion != null && this.designacion.partido != null) {
            if (esLocal) {
                if (this.designacion.partido.listaSuplentesLocal == undefined) {
                    this.designacion.partido.listaSuplentesLocal = [];
                }

                this.designacion.partido.listaSuplentesLocal.forEach(
                    (titular: number, i: number) => {
                        if (titular == idLicencia) {
                            encontrado = true;
                            this.designacion.partido.listaSuplentesLocal.splice(
                                i,
                                1
                            );
                        }
                    }
                );

                if (!encontrado) {
                    this.designacion.partido.listaSuplentesLocal.push(
                        idLicencia
                    );
                }
            } else {
                if (
                    this.designacion.partido.listaSuplentesVisitante ==
                    undefined
                ) {
                    this.designacion.partido.listaSuplentesVisitante = [];
                }

                this.designacion.partido.listaSuplentesVisitante.forEach(
                    (titular: number, i: number) => {
                        if (titular == idLicencia) {
                            encontrado = true;
                            this.designacion.partido.listaSuplentesVisitante.splice(
                                i,
                                1
                            );
                        }
                    }
                );

                if (!encontrado) {
                    this.designacion.partido.listaSuplentesVisitante.push(
                        idLicencia
                    );
                }
            }
            this.GuardarLog(
                esLocal
                    ? JSON.stringify(
                          this.designacion.partido.listaSuplentesLocal
                      )
                    : JSON.stringify(
                          this.designacion.partido.listaSuplentesVisitante
                      ),
                "basePage",
                "EstablecerSuplente",
                "Se establece el suplente en el equipo " +
                    (esLocal ? "local" : "visitante") +
                    " para la licencia " +
                    idLicencia.toString()
            );
        }
    }

    /**
     * Añade en la lista de titulares del equipo local o visitante, la licencia pasada como parámetro. Si ya está en la lista de titulares, la elimina.
     * @param idLicencia    Identificador de la licencia
     * @param esLocal       Indica si es el equipo local
     */
    public EstablecerTitular(idLicencia: number, esLocal: boolean): void {
        let encontrado: boolean = false;

        if (this.designacion != null && this.designacion.partido != null) {
            if (esLocal) {
                if (this.designacion.partido.listaTitularesLocal == undefined) {
                    this.designacion.partido.listaTitularesLocal = [];
                }

                this.designacion.partido.listaTitularesLocal.forEach(
                    (titular: number, i: number) => {
                        if (titular == idLicencia) {
                            encontrado = true;
                            this.designacion.partido.listaTitularesLocal.splice(
                                i,
                                1
                            );
                        }
                    }
                );

                if (!encontrado) {
                    this.designacion.partido.listaTitularesLocal.push(
                        idLicencia
                    );
                }
            } else {
                if (
                    this.designacion.partido.listaTitularesVisitante ==
                    undefined
                ) {
                    this.designacion.partido.listaTitularesVisitante = [];
                }

                this.designacion.partido.listaTitularesLocal.forEach(
                    (titular: number, i: number) => {
                        if (titular == idLicencia) {
                            encontrado = true;
                            this.designacion.partido.listaTitularesVisitante.splice(
                                i,
                                1
                            );
                        }
                    }
                );

                if (!encontrado) {
                    this.designacion.partido.listaTitularesVisitante.push(
                        idLicencia
                    );
                }
            }

            this.GuardarLog(
                esLocal
                    ? JSON.stringify(
                          this.designacion.partido.listaTitularesLocal
                      )
                    : JSON.stringify(
                          this.designacion.partido.listaTitularesVisitante
                      ),
                "basePage",
                "EstablecerTitular",
                "Se establece la titularidad en el equipo " +
                    (esLocal ? "local" : "visitante") +
                    " para la licencia " +
                    idLicencia.toString()
            );
        }
    }

    /**
     * Indica si el identificador de la licencia está en los suplentes del equipo correspondiente
     * @param idLicencia    Identificador de la licencia
     * @param esLocal       Indica si la licencia es del equipo local
     */
    public EsSuplente(idLicencia: number, esLocal: boolean): boolean {
        let resultado: boolean = false;

        if (this.designacion != null && this.designacion.partido != null) {
            // Busca la licencia en la lista de alineados locales o alineados visitante
            if (
                esLocal &&
                this.designacion.partido.listaSuplentesLocal != null &&
                this.designacion.partido.listaSuplentesLocal.length > 0
            ) {
                this.designacion.partido.listaSuplentesLocal.forEach(
                    (valor: number, i: number) => {
                        if (valor == idLicencia) {
                            resultado = true;
                        }
                    }
                );
            }

            if (
                !esLocal &&
                this.designacion.partido.listaSuplentesVisitante &&
                this.designacion.partido.listaSuplentesVisitante.length > 0
            ) {
                this.designacion.partido.listaSuplentesVisitante.forEach(
                    (valor: number, i: number) => {
                        if (valor == idLicencia) {
                            resultado = true;
                        }
                    }
                );
            }
        }

        return resultado;
    }

    /**
     * Comprueba si existe algún alineado marcado en el equipo indicado
     * @param esLocal Indica si se desea consultar el equipo local
     * @returns Booleano
     */
    public TieneAlineados(esLocal: boolean): boolean {
        let resultado: boolean = false;

        if (this.designacion != null && this.designacion.partido != null) {
            // Comprueba si en el equipo local se ha indicado algún titular o algún suplente
            if (
                esLocal &&
                ((this.designacion.partido.listaTitularesLocal != null &&
                    this.designacion.partido.listaTitularesLocal.length > 0) ||
                    (this.designacion.partido.listaSuplentesLocal != null &&
                        this.designacion.partido.listaSuplentesLocal.length >
                            0))
            ) {
                resultado = true;
            } else if (
                !esLocal &&
                ((this.designacion.partido.listaTitularesVisitante != null &&
                    this.designacion.partido.listaTitularesVisitante.length >
                        0) ||
                    (this.designacion.partido.listaSuplentesVisitante != null &&
                        this.designacion.partido.listaSuplentesVisitante
                            .length > 0))
            ) {
                resultado = true;
            }
        }

        return resultado;
    }

    /**
     * Indica si el identificador de la licencia está en los titulares del equipo correspondiente
     * @param idLicencia    Identificador de la licencia
     * @param esLocal       Indica si la licencia es del equipo local
     */
    public EsTitular(idLicencia: number, esLocal: boolean): boolean {
        let resultado: boolean = false;

        if (this.designacion != null && this.designacion.partido != null) {
            // Busca la licencia en la lista de alineados locales o alineados visitante
            if (
                esLocal &&
                this.designacion.partido.listaTitularesLocal != null &&
                this.designacion.partido.listaTitularesLocal.length > 0
            ) {
                this.designacion.partido.listaTitularesLocal.forEach(
                    (valor: number, i: number) => {
                        if (valor == idLicencia) {
                            resultado = true;
                        }
                    }
                );
            }

            if (
                !esLocal &&
                this.designacion.partido.listaTitularesVisitante &&
                this.designacion.partido.listaTitularesVisitante.length > 0
            ) {
                this.designacion.partido.listaTitularesVisitante.forEach(
                    (valor: number, i: number) => {
                        if (valor == idLicencia) {
                            resultado = true;
                        }
                    }
                );
            }
        }

        return resultado;
    }

    /**
     * Indica si el identificador de la licencia pasada como parámetro, está incluida en la lista del quinteto final
     * @param idLicencia Identificador de la licencia
     * @param esLocal Indica si es el equipo local
     */
    public EstaEnQuintetoFinal(idLicencia: number, esLocal: boolean): boolean {
        let resultado: boolean = false;

        if (this.designacion != null && this.designacion.partido) {
            if (
                esLocal &&
                this.designacion.partido.quintetoFinalLocal != undefined &&
                this.designacion.partido.quintetoFinalLocal.length > 0
            ) {
                this.designacion.partido.quintetoFinalLocal.forEach(
                    (valor: number, i: number) => {
                        if (valor == idLicencia) {
                            resultado = true;
                        }
                    }
                );
            }
            if (
                !esLocal &&
                this.designacion.partido.quintetoFinalVisitante != undefined &&
                this.designacion.partido.quintetoFinalVisitante.length > 0
            ) {
                this.designacion.partido.quintetoFinalVisitante.forEach(
                    (valor: number, i: number) => {
                        if (valor == idLicencia) {
                            resultado = true;
                        }
                    }
                );
            }
        }

        return resultado;
    }

    /**
     * Indica si el jugador ha participado en el encuentro: forma parte de un cambio o se ha incluido en la lista de participantes
     * @param idJugador Identificador de la persona
     * @param esLocal   Indica si es el equipo local
     */
    public HaParticipado(idJugador: number, esLocal: boolean): boolean {
        let resultado: boolean = false;

        // Titulares
        if (this.designacion != null && this.designacion.partido != null) {
            if (esLocal) {
                this.designacion.partido.listaTitularesLocal.forEach(
                    (valor: number, i: number) => {
                        if (valor == idJugador) {
                            resultado = true;
                        }
                    }
                );
            } else {
                this.designacion.partido.listaTitularesVisitante.forEach(
                    (valor: number, i: number) => {
                        if (valor == idJugador) {
                            resultado = true;
                        }
                    }
                );
            }

            // Cambios
            if (!resultado) {
                this.designacion.partido.listaCambios.forEach(
                    (valor: Designaciones_Cambios, i: number) => {
                        if (
                            valor.esLocal == esLocal &&
                            valor.entra == idJugador
                        ) {
                            resultado = true;
                        }
                    }
                );
            }

            // Participantes
            if (this.designacion != null && this.designacion.partido != null) {
                if (esLocal) {
                    this.designacion.partido.listaParticipantesLocal.forEach(
                        (valor: number, i: number) => {
                            if (valor == idJugador) {
                                resultado = true;
                            }
                        }
                    );
                } else {
                    this.designacion.partido.listaParticipantesVisitante.forEach(
                        (valor: number, i: number) => {
                            if (valor == idJugador) {
                                resultado = true;
                            }
                        }
                    );
                }
            }
        }
        return resultado;
    }

    /**
     * Devuelve el identificador del jugador/licencia del dorsal pasado como parámetro
     * @param dorsal    Número del dorsal
     * @param esLocal   Indica si es el equipo local
     */
    public IdJugadorPorDorsal(dorsal: number, esLocal: boolean): number {
        let resultado: number = undefined;

        if (this.designacion != null && this.designacion.partido != null) {
            if (esLocal) {
                this.designacion.partido.listaDorsalesLocal.forEach(
                    (valor: Designaciones_Dorsal, i: number) => {
                        if (valor.dorsal == dorsal) {
                            resultado = valor.idJugador;
                        }
                    }
                );
            } else {
                this.designacion.partido.listaDorsalesVisitante.forEach(
                    (valor: Designaciones_Dorsal, i: number) => {
                        if (valor.dorsal == dorsal) {
                            resultado = valor.idJugador;
                        }
                    }
                );
            }
        }

        return resultado;
    }

    /**
     * Devuelve el nombre completo (apellidos y nombre) de la persona cuyo identificador es pasado como parámetro
     * @param idLicencia    Identificador de la licencia
     */
    public NombreCompletoPersona(idLicencia: number, esLocal: boolean): string {
        let resultado: string = "";

        if (this.designacion != null && this.designacion.partido != null) {
            if (esLocal) {
                this.designacion.partido.alineadosLocal.forEach(
                    (valor: Alineados, i: number) => {
                        if (valor.id_Licencia == idLicencia) {
                            resultado =
                                valor.apellido1 +
                                " " +
                                valor.apellido2 +
                                ", " +
                                valor.nombre;
                        }
                    }
                );
            } else {
                this.designacion.partido.alineadosVisitante.forEach(
                    (valor: Alineados, i: number) => {
                        if (valor.id_Licencia == idLicencia) {
                            resultado =
                                valor.apellido1 +
                                " " +
                                valor.apellido2 +
                                ", " +
                                valor.nombre;
                        }
                    }
                );
            }
        }

        return resultado;
    }

    /**
     * Devuelve el número de goles del jugador indicado como parámetro
     * @param idLicencia      Identificador del jugador
     * @param enPropiaPuerta  Indica si se desea que se busque los goles en propia puerta
     */
    public NumeroGoles(
        idLicencia: number,
        enPropiaPuerta: boolean = false
    ): number {
        let resultado: number = 0;

        if (this.designacion != null && this.designacion.partido != null) {
            this.designacion.partido.listaGoles.forEach(
                (valor: Designaciones_Goles, i: number) => {
                    if (
                        valor.idJugador == idLicencia &&
                        valor.propiaPuerta == enPropiaPuerta
                    ) {
                        resultado += 1;
                    }
                }
            );
        }

        return resultado;
    }

    /**
     * Devuelve el número del dorsal que corresponde con la licencia pasada como parámetro. Devuelve 10000 si no ha encontrado el dorsal
     * @param licencia    Licencia a buscar
     * @param dorsales    Lista de dorsales asociados
     */
    private ObtenerDorsal(
        licencia: LicenciasPorEquipo_Licencia,
        dorsales: Array<Designaciones_Dorsal>
    ): number {
        let resultado: number = 10000;

        if (dorsales != null && dorsales.length > 0) {
            dorsales.forEach((valor: Designaciones_Dorsal, i: number) => {
                if (valor.idJugador == licencia.id_Licencia) {
                    resultado = valor.dorsal;
                }
            });
        }

        return resultado;
    }

    /**
     * Devuelve el número del dorsal que corresponde con el alineado pasada como parámetro. Devuelve 10000 si no ha encontrado el dorsal
     * @param alineado    Datos del alineado
     * @param dorsales    Lista de dorsales asociados
     */
    private ObtenerDorsalDeAlineado(
        alineado: Alineados,
        dorsales: Array<Designaciones_Dorsal>
    ): number {
        let resultado: number = 10000;

        if (dorsales != null && dorsales.length > 0) {
            dorsales.forEach((valor: Designaciones_Dorsal, i: number) => {
                if (valor.idJugador == alineado.id_Licencia) {
                    resultado = valor.dorsal;
                }
            });
        }

        return resultado;
    }

    /**
     * Genera las observaciones del partido. Incorpora los mensajes de las opciones internas especiales
     */
    public ObservacionesEnActa(incluirTexto: string = ""): string {
        let resultado: string = "";

        if (this.designacion != null) {
            // Fuerza pública
            if (this.designacion.fuerzaPublica == true) {
                resultado =
                    "<p>El club presenta el <b>formulario</b> de <b>FUERZA PÚBLICA</b>.</p>";
            }

            // Reactivaciones
            if (
                this.designacion.reactivaciones != undefined &&
                this.designacion.reactivaciones.length > 0
            ) {
                this.designacion.reactivaciones.forEach(
                    (valor: string, i: number) => {
                        resultado += valor;
                    }
                );
            }

            // Participación
            if (
                this.EsFutbol8() ||
                this.designacion.competicion.obligatoriaParticipacion
            ) {
                if (
                    this.designacion.partido.listaSuplentesLocal.length !=
                        this.designacion.partido.listaParticipantesLocal
                            .length ||
                    this.designacion.partido.listaSuplentesVisitante.length !=
                        this.designacion.partido.listaParticipantesVisitante
                            .length
                ) {
                    resultado +=
                        "<p>Los siguientes jugadores no han participado en el encuentro:</p>";

                    // Equipo local
                    if (
                        this.designacion.partido.listaSuplentesLocal.length !=
                        this.designacion.partido.listaParticipantesLocal.length
                    ) {
                        this.designacion.partido.listaSuplentesLocal.forEach(
                            (idLicencia: number, i: number) => {
                                let encontrado: boolean = false;
                                this.designacion.partido.listaParticipantesLocal.forEach(
                                    (participante: number, j: number) => {
                                        if (idLicencia == participante) {
                                            encontrado = true;
                                        }
                                    }
                                );

                                if (!encontrado) {
                                    resultado +=
                                        "<p><b>" +
                                        this.designacion.equipoLocal +
                                        "</b>: [" +
                                        this.DorsalPorLicencia(
                                            idLicencia,
                                            true
                                        ) +
                                        "] " +
                                        this.NombreCompletoPersona(
                                            idLicencia,
                                            true
                                        ) +
                                        "</p>";
                                }
                            }
                        );
                    }

                    // Equipo visitante
                    if (
                        this.designacion.partido.listaSuplentesVisitante
                            .length !=
                        this.designacion.partido.listaParticipantesVisitante
                            .length
                    ) {
                        this.designacion.partido.listaSuplentesVisitante.forEach(
                            (idLicencia: number, i: number) => {
                                let encontrado: boolean = false;
                                this.designacion.partido.listaParticipantesVisitante.forEach(
                                    (participante: number, j: number) => {
                                        if (idLicencia == participante) {
                                            encontrado = true;
                                        }
                                    }
                                );

                                if (!encontrado) {
                                    resultado +=
                                        "<p><b>" +
                                        this.designacion.equipoVisitante +
                                        "</b>: [" +
                                        this.DorsalPorLicencia(
                                            idLicencia,
                                            false
                                        ) +
                                        "] " +
                                        this.NombreCompletoPersona(
                                            idLicencia,
                                            false
                                        ) +
                                        "</p>";
                                }
                            }
                        );
                    }
                }
            }

            // Comentarios
            if (
                this.designacion.partido.comentarios != null &&
                this.designacion.partido.comentarios.trim().length > 0
            ) {
                resultado +=
                    "<p>" +
                    this.designacion.partido.comentarios.trim() +
                    "</p>";
            }

            // Incluir texto sumplementario
            resultado += incluirTexto;
        }

        return resultado;
    }

    /**
     * Devuelve el siguiente número de dorsal disponible para el equipo local o visitante
     * @param esLocal       Indica si es el equipo local
     */
    public SiguienteDorsal(esLocal: boolean): number {
        let resultado: number = 0;

        if (this.designacion != null && this.designacion.partido != null) {
            if (esLocal) {
                if (
                    this.designacion.partido.listaDorsalesLocal != null &&
                    this.designacion.partido.listaDorsalesLocal.length > 0
                ) {
                    this.designacion.partido.listaDorsalesLocal.forEach(
                        (valor: Designaciones_Dorsal, i: number) => {
                            if (valor.dorsal >= resultado) {
                                resultado = <number>valor.dorsal + 1;
                            }
                        }
                    );
                } else {
                    this.designacion.partido.listaDorsalesLocal = [];
                    resultado = 1;
                }
            } else {
                if (
                    this.designacion.partido.listaDorsalesVisitante != null &&
                    this.designacion.partido.listaDorsalesVisitante.length > 0
                ) {
                    this.designacion.partido.listaDorsalesVisitante.forEach(
                        (valor: Designaciones_Dorsal, i: number) => {
                            if (valor.dorsal >= resultado) {
                                resultado = <number>valor.dorsal + 1;
                            }
                        }
                    );
                } else {
                    this.designacion.partido.listaDorsalesVisitante = [];
                    resultado = 1;
                }
            }
        }

        return resultado;
    }

    // #endregion

    /**
     * Guardado de una operación realizada
     * @param datos Datos que se quieren guardar
     * @param controlador Nombre del controlador
     * @param metodo Método dentro del controlador
     * @param operacion Operación que se está realizando
     */
    public GuardarLog(
        datos: string | any,
        controlador: string,
        metodo: string,
        operacion: string
    ): void {
        // Guardado del error en la tabla de LOGS
        let log: iLogs = {
            _id: "",
            _rev: "",
            controlador: controlador,
            datos: JSON.stringify(datos),
            datosError: "",
            esError: false,
            fecha: new Date(),
            metodo: metodo,
            operacion: operacion,
            type: "",
            idDesignacion:
                this.designacion != null && this.designacion.id_Designacion > 0
                    ? this.designacion.id_Designacion
                    : 0,
        };
        this.DBService.CrearLog(log)
            .then((resultado) => {
                console.log(resultado);
            })
            .catch((error) =>
                this.Error(error, controlador, metodo, operacion)
            );
    }

    /**
     * Presenta un mensaje informando del error
     * @param texto Explicación del error
     * @param controlador Controlador donde se generó el error
     * @param metodo  Método donde se generó el error
     * @param operacion Operación que se estaba realizando
     */
    public Error(
        texto: string | any,
        controlador: string,
        metodo: string,
        operacion: string
    ): void {
        // Guardado del error en la tabla de LOGS
        let log: iLogs = {
            _id: "",
            _rev: "",
            controlador: controlador,
            datos: "",
            datosError: JSON.stringify(texto),
            esError: true,
            fecha: new Date(),
            metodo: metodo,
            operacion: operacion,
            type: "",
            idDesignacion:
                this.designacion != null && this.designacion.id_Designacion > 0
                    ? this.designacion.id_Designacion
                    : 0,
        };
        this.DBService.CrearLog(log);

        let toast = this.toastCtrl.create({
            message: operacion,
            position: "bottom",
            cssClass: "urgent-notificacion",
            showCloseButton: true,
            closeButtonText: "OK",
        });
        toast.present();
        try {
            this.carga.dismiss();
        } catch (error) {}
    }

    /**
     * Muestra un mensaje en forma de 'toast'
     * @param texto   Texto a mostrar
     * @param clase   Clase asociada
     * @param duracion    Duración en milisegundos del mensaje. En el caso de que se especifique 0, se mostrará el 'toast' con un botón de OK para cerrar el mensaje
     */
    public Mensaje(texto: string, clase: string, duracion: number): void {
        if (duracion == 0) {
            let toast = this.toastCtrl.create({
                message: texto,
                position: "bottom",
                cssClass: clase,
                showCloseButton: true,
                closeButtonText: "OK",
            });
            toast.present();
        } else {
            let toast = this.toastCtrl.create({
                message: texto,
                position: "bottom",
                cssClass: clase,
                duration: duracion,
            });
            toast.present();
        }
    }

    /**
     * Muestra una pequeña ventana de carga
     * @param texto Texto que se mostrará en la ventana de carga (opcional)
     */
    public MostrarCarga(texto?: string): void {
        try {
            this.carga = this.loadingCtrl.create({
                spinner: "dots",
                content: texto != undefined ? texto : "cargando",
            });
            this.carga.present();
        } catch (e) {}
    }

    /**
     * Devuelve un texto con la versión de la aplicación.
     */
    public NumeroVersion(): Promise<string> {
        return new Promise((resolve, reject) => {
            if (this.configuraciones != undefined) {
                resolve(this.configuraciones.version);
            } else {
                this.http
                    .get("./assets/data/datos.json")
                    .toPromise()
                    .then((res: any) => {
                        this.configuraciones = <iConfiguracion>res.json();
                        resolve(this.configuraciones.version);
                    })
                    .catch((error) =>
                        this.Error(
                            error,
                            "basePage",
                            "NumeroVersion",
                            "Obteniendo los datos de configuración del archivo datos.json"
                        )
                    );
            }
        });
    }

    /**
     * Oculta la ventana de carga
     */
    public OcultarCarga(): void {
        try {
            this.carga.dismissAll();
        } catch (e) {}
    }
    // #endregion
}



// WEBPACK FOOTER //
// ./src/models/basePage.ts